import { useParams } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { ResetPasswordPage } from './ResetPasswordPage';

export function ResetPasswordRoute(): ReactElement {
    const { otp } = useParams({ from: '/split-hero-layout/reset-password/$otp' });
    return <ResetPasswordPage otp={otp} />;
}
